module.exports = __webpack_public_path__ + "static/media/logo_SPA.0f1e6d37.svg";